// extracted by mini-css-extract-plugin
export default {"root":"CUaUYUO12Q","supportInfo":"BHxBVaWEwC"};